export default __webpack_public_path__ + "static/Group 1967-3b5409e9a1a38204b3bbe8e3c3c7cdb9.png";